import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { ActivityFeedPage } from '../pages/ActivityFeedPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/activity-feed' as any)({
  component: () => (
    <MainLayout>
      <ActivityFeedPage />
    </MainLayout>
  ),
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) throw redirect({ to: '/login' })
  },
})
